"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SiteSearchPage;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _useDynamicQuickLinks = _interopRequireDefault(require("./useDynamicQuickLinks"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _siteSearchContext = require("./site-search-context");
var _index = _interopRequireDefault(require("./search-bar/index"));
var _quickLinks = _interopRequireDefault(require("../../navigation/header/site-search/quick-links"));
var _results = _interopRequireDefault(require("./results"));
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
var _hooks = require("./serp-results/hooks");
var _functions = require("./utils/functions");
var _uawColumnPlacement = _interopRequireDefault(require("../../elements/widgets/universal-ad-widget/uaw-column-placement"));
var _helper = require("../../elements/widgets/universal-ad-widget/helper");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable max-statements */

const SiteSearchPageContainer = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "SiteSearchPageContainer",
  class: "pl-s1e2o16k"
});
const SearchBarContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SearchBarContainer",
  class: "pl-s1vtjss9"
});
const ResultsContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ResultsContainer",
  class: "pl-rsvnro5"
});
const ArrowUpContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ArrowUpContainer",
  class: "pl-at6jl8v"
});
const Arrow = /*#__PURE__*/(0, _react2.styled)(_icon.Icon)({
  name: "Arrow",
  class: "pl-a19v3457"
});
const QuickLinksContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "QuickLinksContainer",
  class: "pl-q1nvdetm"
});
const adPlacementKey = 'gd-site-search-pos1';

/**
  * Render Site Search Page Component.
  *
  * @param {object} props React props for element
  * @param {string} props._name Name
  * @param {string} props._id Id
  * @param {object} props.searchBar Search Bar
  * @param {object} props.searchHeadline Search Headline
  * @param {object} props.filterNav Search Headline
  * @param {object} props.categorySections Category Sections
  * @param {Array} props.quickLinks Quick Links
  * @param {string} props.quickLinksLabel Quick Links Label
  * @param {string} props.autocompleteEndpoint Autocomplete Endpoint
  * @param {string} props.resultsEndpoint Results Endpoint
  * @param {string} props.fuzzy Fuzzy
  * @param {string} props.domainSearchEndpoint Domain Search Endpoint
  * @param {object} props.searchBanner Search Banner
  * @param {string} props.aiPoweredTagText AI Tag Text
  * @param {object} props.searchSerp Domain Search Serp
  * @param {number} props.searchStringMinLength Search String minimal length
  * @param {string} props.appKeyHeader App Key Header for Content API access
  * @returns {React.ReactElement} Site Search Page component
  * @public
  */
function SiteSearchPage({
  placeholder,
  clearAriaLabel,
  popularListLabel,
  suggestionsListLabel,
  resultsListLabel,
  noResultsListLabel,
  resultsExternalPaths,
  headlineTemplate,
  filterNav,
  categorySections,
  title,
  quickLinks,
  quickLinksLabel,
  resultsEndpoint,
  fuzzy = true,
  domainSearchEndpoint,
  autocompleteEndpoint,
  searchBanner,
  searchSerp,
  suggestedSearchesHeadline,
  headline,
  source = 'es',
  helpSource = 'api',
  aiPoweredTagText,
  searchStringMinLength = _patternLibraryUtils.SEARCH_MIN_LENGTH,
  sponsoredLabel,
  universalAdWidgetConfig,
  appKeyHeader = 'fos-pattern-library'
}) {
  const [searchValue, setSearchValue] = (0, _patternLibraryUtils.useQueryParam)('q', '');
  const [value, setValue] = (0, _react.useState)('');
  const [step, setStep] = (0, _react.useState)('initial');
  const [results, setResults] = (0, _react.useState)();
  const [activeFilter, setActiveFilter] = (0, _react.useState)('all');
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  const [domainSearchUrl, setDomainSearchUrl] = (0, _react.useState)(domainSearchEndpoint);
  const [suggestedList, setSuggestedList] = (0, _react.useState)([]);
  const [list, setList] = (0, _react.useState)(suggestedList);
  const [isActive, setIsActive] = (0, _react.useState)(false);
  const [isAI, setIsAI] = (0, _react.useState)(false);
  const [trackingCustomProperties, setTrackingCustomProperties] = (0, _react.useState)({});
  const [currentDomainSearch, setCurrentDomainSearch] = (0, _react.useState)(searchSerp);
  const {
    isLoading: searchDataIsLoading,
    searchData
  } = (0, _hooks.useDomainSearch)(searchValue, currentDomainSearch);
  const autocomplete = (0, _react.useCallback)(async (keyword, callback, abortController) => {
    if (typeof window !== 'undefined') {
      const apiUrl = new URL(autocompleteEndpoint);
      const {
        searchParams
      } = apiUrl;
      searchParams.set('q', (0, _functions.sanitizeDomainQuery)(keyword));
      const urlString = apiUrl.href;
      try {
        const res = await fetch(urlString, {
          method: 'GET',
          signal: abortController.signal,
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'X-App-Key': appKeyHeader
          }
        });
        const data = await res.json();
        if (data.length > 0) {
          setList(data);
        } else {
          setList([]);
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
      if (callback) {
        return callback();
      }
    }
  }, [autocompleteEndpoint]);
  const search = (0, _react.useCallback)(async (keyword, abortController) => {
    const addSiteSearchCodeTracking = data => {
      Object.values(data).forEach(result => {
        if (result?.url?.includes('/how-to') || result?.url?.includes('/help')) {
          result.breadcrumbs?.forEach(breadcrumb => {
            breadcrumb.url += '?src=site_search';
          });
          result.url += '?src=site_search';
        }
      });
      return data;
    };
    const apiUrl = new URL(resultsEndpoint);
    const {
      searchParams
    } = apiUrl;
    searchParams.set('q', (0, _functions.sanitizeDomainQuery)(keyword));
    searchParams.set('f', fuzzy);
    searchParams.set('source', source);
    searchParams.set('helpSource', helpSource);
    setIsLoading(true);
    try {
      const res = await fetch(apiUrl.href, {
        method: 'GET',
        signal: abortController?.signal || null,
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-App-Key': appKeyHeader
        }
      });
      const data = await res.json();
      for (const key in data) {
        if (data[key] && data[key].length === 0) {
          delete data[key];
        }
      }
      const {
        source: dataSource
      } = data;
      setIsAI(dataSource === 'ai');
      const categories = ['products', 'help', 'resources', 'how-to'];
      const hasResults = Object.keys(data).some(key => categories.includes(key));
      if (hasResults) {
        const dataWithTracking = addSiteSearchCodeTracking(data);
        setResults(dataWithTracking);
      } else {
        setResults(null);
      }
    } catch (err) {
      setIsLoading(true);
      if (err.name === 'AbortError') {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    }
    setIsLoading(false);
  }, [resultsEndpoint, fuzzy, setIsLoading, setResults, helpSource, source]);
  const handleOnConfirm = (0, _react.useCallback)((searchTerm, event, abortController) => {
    if (searchTerm?.length >= searchStringMinLength) {
      const keywordLowerCase = (0, _functions.sanitizeDomainQuery)(searchTerm.trim().toLowerCase());
      setValue(keywordLowerCase);
      setSearchValue(keywordLowerCase);
      search(keywordLowerCase, abortController);
    }
    if (event?.type === 'popstate' && searchTerm?.length === 0) {
      setSearchValue('');
    }
    setIsActive(false);
    setStep('results');
  }, [search, setSearchValue, searchStringMinLength]);
  const abortMessage = 'Aborted: Request cancelled to avoid duplication of search queries.';
  (0, _react.useEffect)(() => {
    const abortController = new AbortController();
    const getInitialSuggestions = async () => {
      try {
        const sessionSuggestions = JSON.parse(sessionStorage.getItem('suggestedList'));
        // check if sessionSuggestions is an array of strings
        if (Array.isArray(sessionSuggestions) && sessionSuggestions.length > 0 && typeof sessionSuggestions[0] === 'string') {
          setSuggestedList(sessionSuggestions);
        }
      } catch (err) {
        setIsLoading(true);
      }
      if (suggestedList.length === 0) {
        try {
          const res = await fetch(autocompleteEndpoint, {
            method: 'GET',
            signal: abortController.signal,
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
              'X-App-Key': appKeyHeader
            }
          });
          const data = await res.json();
          setSuggestedList(data);
          sessionStorage.setItem('suggestedList', JSON.stringify(data));
        } catch (err) {
          if (err.name === 'AbortError') {
            // eslint-disable-next-line no-console
            console.error(err);
          }
        } finally {
          setIsLoading(false);
        }
      }
    };
    if (suggestedList.length === 0) {
      getInitialSuggestions();
    }
    return () => {
      abortController.abort(abortMessage);
    };
  }, [autocompleteEndpoint, setIsLoading, setSuggestedList, suggestedList]);
  (0, _react.useEffect)(() => {
    const abortController = new AbortController();
    if (searchValue?.length >= searchStringMinLength) {
      autocomplete(searchValue, null, abortController);
      handleOnConfirm(searchValue, null, abortController);
    }
    // When search value changes, update domain search url with new search value
    if (domainSearchUrl) {
      const url = new URL(domainSearchUrl);
      url.searchParams.set('domainToCheck', searchValue);
      setDomainSearchUrl(url.href.toString());
    }
    return () => {
      abortController.abort(abortMessage);
    };
  }, [searchValue, autocomplete, domainSearchUrl, handleOnConfirm, searchStringMinLength]);
  const quickLinksProps = {
    quickLinks: quickLinks,
    quickLinksLabel: quickLinksLabel
  };
  const quickLinksPropsWithQuery = (0, _useDynamicQuickLinks.default)(searchValue, quickLinksProps);
  const searchBarProps = {
    autocompleteEndpoint,
    placeholder,
    clearAriaLabel,
    popularListLabel,
    suggestionsListLabel,
    resultsListLabel,
    noResultsListLabel
  };
  return /*#__PURE__*/_react.default.createElement(_siteSearchContext.SiteSearchContext.Provider, {
    value: {
      autocomplete,
      value,
      setValue,
      searchValue,
      isLoading,
      isActive,
      setIsActive,
      step,
      setStep,
      results,
      activeFilter,
      setActiveFilter,
      suggestedList,
      list,
      setList,
      domainSearchUrl,
      searchBanner,
      resultsExternalPaths,
      suggestedSearchesHeadline,
      handleOnConfirm,
      highlightKeyword: _functions.highlightKeyword,
      trackingCustomProperties,
      setTrackingCustomProperties,
      searchSerp,
      searchData,
      searchDataIsLoading,
      currentDomainSearch,
      setCurrentDomainSearch
    }
  }, /*#__PURE__*/_react.default.createElement(SiteSearchPageContainer, {
    dataCy: "site-search-page"
  }, /*#__PURE__*/_react.default.createElement(SearchBarContainer, null, /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({}, searchBarProps, {
    trackingV2: true
  }))), /*#__PURE__*/_react.default.createElement(ResultsContainer, null, results && aiPoweredTagText && isAI && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_tag.default, {
    style: {
      fontSize: '0.79rem'
    },
    text: aiPoweredTagText,
    design: 'info'
  })), /*#__PURE__*/_react.default.createElement(_results.default, {
    title: title,
    headlineTemplate: headlineTemplate,
    filterNav: filterNav,
    categorySections: categorySections,
    headline: headline
  }), /*#__PURE__*/_react.default.createElement(ArrowUpContainer, (0, _extends2.default)({
    onClick: _patternLibraryUtils.scrollToTop,
    tabIndex: 0,
    "data-cy": "scroll-up-link"
  }, _patternLibraryUtils.tracking.create(`back_to_top`, true, false, trackingCustomProperties)), /*#__PURE__*/_react.default.createElement(Arrow, {
    name: "arrow-up"
  }))), /*#__PURE__*/_react.default.createElement(QuickLinksContainer, null, /*#__PURE__*/_react.default.createElement(_quickLinks.default, quickLinksPropsWithQuery), universalAdWidgetConfig && /*#__PURE__*/_react.default.createElement(_uawColumnPlacement.default, {
    adPlacementKey: adPlacementKey,
    universalAdWidgetConfig: (0, _helper.selectUawEnvironmentConfig)((0, _helper.parseUawEnvironmentConfigs)(universalAdWidgetConfig)),
    sponsoredLabel: sponsoredLabel
  }))));
}
SiteSearchPage.propTypes = {
  _name: _propTypes.default.string,
  id: _propTypes.default.string,
  filterNav: _propTypes.default.object.isRequired,
  categorySections: _propTypes.default.array.isRequired,
  quickLinks: _propTypes.default.array.isRequired,
  quickLinksLabel: _propTypes.default.string.isRequired,
  autocompleteEndpoint: _propTypes.default.string.isRequired,
  fuzzy: _propTypes.default.bool,
  resultsEndpoint: _propTypes.default.string.isRequired,
  placeholder: _propTypes.default.string.isRequired,
  searchAriaLabel: _propTypes.default.string,
  domainSearchEndpoint: _propTypes.default.string.isRequired,
  searchBanner: _propTypes.default.object,
  searchSerp: _propTypes.default.object,
  clearAriaLabel: _propTypes.default.string,
  popularListLabel: _propTypes.default.string.isRequired,
  suggestionsListLabel: _propTypes.default.string.isRequired,
  resultsListLabel: _propTypes.default.string.isRequired,
  noResultsListLabel: _propTypes.default.string.isRequired,
  resultsExternalPaths: _propTypes.default.string.isRequired,
  headlineTemplate: _propTypes.default.string.isRequired,
  title: _propTypes.default.string.isRequired,
  suggestedSearchesHeadline: _propTypes.default.string.isRequired,
  headline: _propTypes.default.string.isRequired,
  source: _propTypes.default.string,
  helpSource: _propTypes.default.string,
  aiPoweredTagText: _propTypes.default.string,
  searchStringMinLength: _propTypes.default.number,
  sponsoredLabel: _propTypes.default.string,
  universalAdWidgetConfig: _propTypes.default.string,
  appKeyHeader: _propTypes.default.string
};